import { Component, Vue } from "vue-property-decorator";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class StandardReferences extends Vue {
  private get _references() {
    return this.$store.getters[`${patientNamespace.namespace}/references`];
  }
  get references() {
    if (this._references) {
      return this._references.standard;
    }
    return false;
  }

  makeRefDisplay(a: any) {
    let display = ""; //a.title;

    if (a.year !== null && a.source != null) {
      if (a.author !== null) {
        display += a.author + ", ";
      }

      display += a.source + ", " + a.year;
    }
    return display;
  }
  makeRefLink(ref: any) {
    return ref.isDoc == true ? "docs/" + ref.fileName : ref.fileName;
  }
}
